import { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .get("/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await client.post("/auth/login", { email, password });
    if (res.data.token) localStorage.setItem("mv_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const setSession = (u, token) => {
    if (token) localStorage.setItem("mv_token", token);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try {
      await client.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("mv_token");
    localStorage.removeItem("mv_workspace");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
